import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  DrawingFilters,
  DrawingOptions,
  PartialCreateDrawingValues,
} from '../../models/drawings/drawings.model';

type DrawingsPanelState = {
  initialFormValues: PartialCreateDrawingValues;
  nameDescriptionValues: Record<string, any>;
  searchFilterValue: string;
  filters: DrawingFilters;
  drawingOptions: DrawingOptions;
};

// The colours in here have to be hexalpha or the drawings fail
export const DEFAULT_DRAWING_COLOUR = '#47902C';
export const DEFAULT_DRAWING_OPACITY = 0.3;

export const INITIAL_DRAWINGS_PANEL_STATE: DrawingsPanelState = {
  initialFormValues: {} as PartialCreateDrawingValues,
  nameDescriptionValues: { name: '', description: '' },
  searchFilterValue: '',
  filters: {
    startDate: null,
    endDate: null,
    ownerTypes: [],
    open: false,
  },
  drawingOptions: {
    drawingColour: DEFAULT_DRAWING_COLOUR,
    drawingOpacity: DEFAULT_DRAWING_OPACITY,
    drawingHexAlpha: '#47902C6e',
  },
};

const DrawingsPanelSlice = createSlice({
  name: 'drawingsPanel',
  initialState: INITIAL_DRAWINGS_PANEL_STATE,
  reducers: {
    setInitialFormValues: (
      state,
      action: PayloadAction<PartialCreateDrawingValues>
    ) => {
      state.initialFormValues = action.payload;
    },
    setNameDescriptionValues: (
      state,
      action: PayloadAction<Record<string, any>>
    ) => {
      state.nameDescriptionValues = action.payload;
    },
    setSearchFilterValue: (state, action: PayloadAction<string>) => {
      state.searchFilterValue = action.payload;
    },
    setDrawingOptions: (
      state,
      action: PayloadAction<Partial<DrawingOptions> | null>
    ) => {
      // Only updates options explictly mentioned in action
      state.drawingOptions = {
        ...state.drawingOptions,
        ...action.payload,
      };
    },
  },
});

export const {
  setInitialFormValues,
  setNameDescriptionValues,
  setSearchFilterValue,
  setDrawingOptions,
} = DrawingsPanelSlice.actions;

export default DrawingsPanelSlice.reducer;
